import React from 'react'
import { PageTitle } from '../../../../_metronic/layout/core'
import AdminHowToVideosPage from './AdminHowToVideosPage'

const AdminHowToVideosWrapper = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>How-To Videos Management</PageTitle>
      
      <AdminHowToVideosPage />
    </>
  )
}

export default AdminHowToVideosWrapper